import type { DataContainer } from "@otto-ec/tracking-bct";

export enum ActivationStatus {
	DEACTIVATED = "DEACTIVATED",
	ACTIVATED = "ACTIVATED",
}

export class Tracking {
	constructor(
		readonly id: string,
		readonly name: string,
		readonly labels: DataContainer,
	) {}
}

export enum ShowCallToAction {
	ACTIVATED_SLIDER = "ACTIVATED_SLIDER",
	DEACTIVATED_SLIDER = "DEACTIVATED_SLIDER",
	BUTTON_TO_APP = "BUTTON_TO_APP",
}

export class DetailviewBenefit {
	activationStatus: ActivationStatus;

	constructor(
		readonly id: string,
		readonly bounceBenefitId: string,
		readonly activationBenefitId: string,
		readonly scarcityValue: number,
		readonly activeUntil: Date,
		readonly activationUrl: string,
		readonly sheetUrl: string,
		readonly activatedHeadlineText: string,
		readonly activatedSliderText: string,
		readonly deactivatedHeadlineText: string,
		readonly deactivatedSliderText: string,
		activationStatus: ActivationStatus,
		readonly tracking: Tracking,
		readonly showCallToAction: ShowCallToAction,
		readonly adjustLink?: string,
	) {
		this.activationStatus = activationStatus;
	}
}
